// src/modules/manualJournal/constants.js

export const ACCOUNT_CATEGORIES = [
  { value: 'CASH_HAND', label: 'Cash in Hand', icon: '💵' },
  { value: 'BANK', label: 'Bank', icon: '🏦' },
  { value: 'PAYABLES', label: 'Payables (Creditors)', icon: '📤' },
  { value: 'RECEIVABLES', label: 'Receivables (Debtors)', icon: '📥' },
  { value: 'INVENTORY', label: 'Inventory', icon: '📦' },
  { value: 'PROFIT_LOSS', label: 'Profit/Loss', icon: '📊' },
  { value: 'GENERAL', label: 'General Income/Expense', icon: '💰' },
];

export const TRANSACTION_TYPES = [
  { value: 'DEBIT', label: 'Debit', color: 'red' },
  { value: 'CREDIT', label: 'Credit', color: 'green' },
  { value: 'TRANSFER', label: 'Transfer', color: 'blue' },
  { value: 'ADJUSTMENT', label: 'Adjustment', color: 'orange' },
];

export const DAY_STATUSES = [
  { value: 'DRAFT', label: 'Draft', color: 'gold' },
  { value: 'FINALIZED', label: 'Finalized', color: 'green' },
];

export const getCategoryLabel = (value) => {
  const category = ACCOUNT_CATEGORIES.find((c) => c.value === value);
  return category ? category.label : value;
};

export const getCategoryIcon = (value) => {
  const category = ACCOUNT_CATEGORIES.find((c) => c.value === value);
  return category ? category.icon : '📝';
};
